import { Carousel } from '@components/primitives/Carousel'
import { Text } from '@components/primitives/Text'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import type { TrackingSources } from '@lib/tracking/TrackingSources'
import type { CardTopicData } from '../DirectoryCategoryCard'
import { TreatmentTopicCategoryCard } from '../TreatmentTopicCategoryCard'

interface TreatmentTopicCardCarouselProps {
  cards: CardTopicData[]
  icon: IconDefinition
  subheading: string
  trackingSource: TrackingSources
}

/** Horizontal carousel for showing treatment topic cards **/
export function TreatmentTopicCardCarousel({
  cards,
  icon,
  subheading,
  trackingSource,
}: TreatmentTopicCardCarouselProps) {
  return (
    <>
      <Text
        className='mb-4 text-neutral900'
        element='h3'
        styleName='h4'
        value={subheading}
      />

      <Carousel centerVertically={false} className='gap-4'>
        {cards.map((card, index) => (
          <TreatmentTopicCategoryCard
            {...card}
            href={
              card.href ? card.href : DynamicRoutes.treatmentTopic(card.slug)
            }
            icon={icon}
            index={index}
            key={card.subtitle}
            trackingSource={trackingSource}
          />
        ))}
      </Carousel>
    </>
  )
}
